module.exports = __webpack_public_path__ + "img/afternoon.c6ebf4ec.jpg";